import MRStops from 'components/form/MRStops/styled';

export default MRStops;
